import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/Logo_Dojo.png'
import _imports_1 from '@/assets/icons/Icone_LogIn_DOJO.png'
import _imports_2 from '@/assets/icons/Icone_LivretRegle_DOJO.png'
import _imports_3 from '@/assets/icons/Icone_Video_DOJO.png'
import _imports_4 from '@/assets/icons/Icone_FAQ_DOJO.png'
import _imports_5 from '@/assets/icons/Icone_Tchat_DOJO.png'
import _imports_6 from '@/assets/icons/Icone_Tchat_Actif_DOJO.png'


const _withScopeId = n => (_pushScopeId("data-v-45117f11"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-bar__content" }
const _hoisted_2 = {
  key: 0,
  alt: "Logo Dojo",
  src: _imports_0
}
const _hoisted_3 = { class: "menu-item menu-item--has-component" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-item__icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "",
    src: _imports_1
  })
], -1))
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"menu-bar__line\" data-v-45117f11><a class=\"menu-item menu-item__hoverable\" href=\"https://drive.google.com/open?id=17LQ60V8D14bdGvmDWktkKopFEWzcmqlv\" target=\"_blank\" data-v-45117f11><div class=\"menu-item__icon\" data-v-45117f11><img alt=\"\" src=\"" + _imports_2 + "\" data-v-45117f11></div><div class=\"menu-item__title menu-item__small_btn\" data-v-45117f11>Livret de règles</div></a><a class=\"menu-item menu-item__hoverable\" href=\"https://youtu.be/4qBFUyZrpcQ\" target=\"_blank\" data-v-45117f11><div class=\"menu-item__icon\" data-v-45117f11><img alt=\"\" src=\"" + _imports_3 + "\" data-v-45117f11></div><div class=\"menu-item__title menu-item__small_btn\" data-v-45117f11>Vidéo de règles</div></a></div>", 1)
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-item__icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "",
    src: _imports_4
  })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-item__title" }, "Foire aux questions", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "menu-item menu-item--has-component" }
const _hoisted_10 = { class: "menu-item__icon" }
const _hoisted_11 = {
  key: 0,
  alt: "",
  src: _imports_5
}
const _hoisted_12 = {
  key: 1,
  alt: "",
  src: _imports_6
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-item__title" }, "Crédits", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-item menu-item__not_hoverable" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "menu-item__title" }, "Dons & Illustrations")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActionHistory = _resolveComponent("ActionHistory")!
  const _component_Chat = _resolveComponent("Chat")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([['menu-bar--' + _ctx.state], "menu-bar"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass([{
                    logo__closed: !_ctx.menu_data.menu_bar_opened,
                    logo__opened: _ctx.menu_data.menu_bar_opened,
                }, "logo"]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.askConfirmExit && _ctx.askConfirmExit(...args)))
      }, [
        (_ctx.menu_data.menu_bar_opened)
          ? (_openBlock(), _createElementBlock("img", _hoisted_2))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.menu_data.menu_bar_opened)
          ? (_openBlock(), _createBlock(_component_ActionHistory, {
              key: 0,
              class: "menu-item__component"
            }))
          : _createCommentVNode("", true)
      ]),
      _hoisted_5,
      _createElementVNode("div", {
        class: "menu-item menu-item__hoverable",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.displaySection('faq')))
      }, _hoisted_8),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          (!_ctx.menu_data.new_chat_message)
            ? (_openBlock(), _createElementBlock("img", _hoisted_11))
            : _createCommentVNode("", true),
          (_ctx.menu_data.new_chat_message)
            ? (_openBlock(), _createElementBlock("img", _hoisted_12))
            : _createCommentVNode("", true)
        ]),
        (_ctx.menu_data.menu_bar_opened)
          ? (_openBlock(), _createBlock(_component_Chat, {
              key: 0,
              class: "menu-item__component"
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: "menu-item menu-item__hoverable",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.displaySection('credits')))
      }, _hoisted_14),
      _hoisted_15,
      _createElementVNode("div", {
        class: "menu-bar__arrow-button",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
      }, _toDisplayString(_ctx.menu_bar_opened ? "<" : ">"), 1)
    ]),
    _createElementVNode("div", {
      class: "fullscreen-button",
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleFullScreen && _ctx.toggleFullScreen(...args)))
    })
  ], 2))
}